const buttonWrapperCls = "_61b3l667h";
const guideBubbleCls = "_61g12yi6at";
const iconWrapper = "_61i1jaep9s";
const lightbulb = "_61l1v5tg5t";
const throbberWrapperCls = "_61tc3161z";
const throbberCls = "_61t1wrjklx";

export { buttonWrapperCls, guideBubbleCls, iconWrapper, lightbulb, throbberCls, throbberWrapperCls };
import "./atom.resource-button.style.linaria.module.css";
//# sourceMappingURL=atom.resource-button.style.js.map
